import { render, staticRenderFns } from "./ClientRecruiterList.vue?vue&type=template&id=198f2ec4&"
import script from "./ClientRecruiterList.vue?vue&type=script&lang=js&"
export * from "./ClientRecruiterList.vue?vue&type=script&lang=js&"
import style0 from "./ClientRecruiterList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports